import axios from "axios";
import { SENSOR_CLASS_LIST_URL } from '../../config/landlordLinks.jsx'
import {toast} from 'react-toastify'

export const FETCH_LL_SENSOR_CLASS_LIST = 'FETCH_LL_SENSOR_CLASS_LIST'
export const RECEIVE_LL_SENSOR_CLASS_LIST = 'RECEIVE_LL_SENSOR_CLASS_LIST'
export const FAILED_LL_SENSOR_CLASS_LIST = 'FAILED_LL_SENSOR_CLASS_LIST'

export function fetchLLSensorClassList(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_LL_SENSOR_CLASS_LIST});
        axios({
            method: 'post',
            url: SENSOR_CLASS_LIST_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_LL_SENSOR_CLASS_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_LL_SENSOR_CLASS_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_LL_SENSOR_CLASS_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_LL_SENSOR_CLASS_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_LL_SENSOR_CLASS_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_LL_SENSOR_CLASS_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_LL_SENSOR_CLASS_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}